const bars = [42, 58, 38, 66, 52, 78, 64];

export const CrmDashboard = ({ compact = false }) => (
  <div
    className="flex h-full w-full overflow-hidden rounded-xl border border-kryvo-line bg-white text-left shadow-[0_24px_60px_-24px_rgba(8,122,61,0.28)]"
    data-testid="crm-dashboard-mockup"
  >
    {/* Sidebar */}
    <div className="hidden w-14 flex-col items-center gap-4 border-r border-kryvo-line bg-kryvo-mist py-4 sm:flex">
      <span className="h-7 w-7 rounded-lg bg-kryvo-green" />
      {["Leads", "Contacts", "Deals", "Tasks"].map((label, i) => (
        <span
          key={label}
          title={label}
          className={`h-8 w-8 rounded-lg ${
            i === 0 ? "bg-kryvo-soft ring-1 ring-kryvo-green/30" : "bg-white"
          }`}
        />
      ))}
    </div>

    <div className="flex min-w-0 flex-1 flex-col">
      {/* Topbar */}
      <div className="flex items-center justify-between border-b border-kryvo-line px-4 py-3">
        <div>
          <p className="font-display text-[13px] font-semibold text-kryvo-ink">Kryvo CRM</p>
          <p className="text-[10px] text-kryvo-sub">Sales Overview</p>
        </div>
        <span className="rounded-full bg-kryvo-lime/25 px-2.5 py-1 text-[10px] font-semibold text-kryvo-deep">
          Live
        </span>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-3 gap-2 px-4 pt-3">
        {[
          { label: "Leads", value: "New leads" },
          { label: "Opportunities", value: "Open deals" },
          { label: "Revenue", value: "This quarter" },
        ].map((s) => (
          <div key={s.label} className="rounded-lg border border-kryvo-line bg-kryvo-mist/70 px-2.5 py-2">
            <p className="text-[9px] font-medium uppercase tracking-wider text-kryvo-sub">{s.label}</p>
            <p className="text-[11px] font-semibold text-kryvo-green">{s.value}</p>
          </div>
        ))}
      </div>

      {/* Chart + pipeline */}
      <div className="grid flex-1 grid-cols-5 gap-2 p-4">
        <div className="col-span-3 flex flex-col rounded-lg border border-kryvo-line p-3">
          <p className="mb-2 text-[10px] font-semibold text-kryvo-ink/70">Revenue trend</p>
          <div className="flex flex-1 items-end gap-1.5">
            {bars.map((h, i) => (
              <span
                key={i}
                style={{ height: `${h}%` }}
                className={`flex-1 rounded-sm ${i === 5 ? "bg-kryvo-lime" : "bg-kryvo-green/25"}`}
              />
            ))}
          </div>
        </div>
        <div className="col-span-2 flex flex-col gap-1.5 rounded-lg border border-kryvo-line p-3">
          <p className="mb-1 text-[10px] font-semibold text-kryvo-ink/70">Pipeline</p>
          {[
            { stage: "Qualified", w: "w-3/4", tone: "bg-kryvo-green/30" },
            { stage: "Proposal", w: "w-1/2", tone: "bg-kryvo-green/50" },
            { stage: "Won", w: "w-2/3", tone: "bg-kryvo-lime" },
          ].map((p) => (
            <div key={p.stage}>
              <p className="text-[9px] text-kryvo-sub">{p.stage}</p>
              <div className="mt-0.5 h-1.5 w-full rounded-full bg-kryvo-mist">
                <div className={`h-full rounded-full ${p.w} ${p.tone}`} />
              </div>
            </div>
          ))}
          {!compact && (
            <div className="mt-auto rounded-md bg-kryvo-mist px-2 py-1.5 text-[9px] text-kryvo-sub">
              Tasks due today
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
);

export default CrmDashboard;
